import { PUBLIC } from './helper/const';
import { defineStore } from 'pinia';
export const useStore = defineStore('main', {
    state: () => ({
        altId: '',
        altType: '',
        companyId: '',
        allowedExtensions: [],
        maxUploadSize: {
            image: 100000000,
            document: 100000000,
            video: 4000000000,
            audio: 100000000,
        },
        application: 'media-center',
        appState: '',
        fileList: [],
        currentPath: '',
        uploadQueue: [],
        activeItem: {},
        tokenId: '',
        directoryRoute: [],
        apiKey: '',
        retryCount: 0,
        selfHosted: false,
        contentAIEnable: false,
        loading: true,
        mediaModal: false,
        activeCategory: 'my_media',
        previewItem: {},
        selectedItems: [],
        isMultiSelectMode: false,
        isDragStarted: false,
        processingQueue: [],
        allowMultipleFileInsertion: false,
        googleConnectionInfo: [],
        processingType: '',
        enableGoogleDrive: false,
        levelUpDate: new Date('2024-10-21T00:00:00-04:00'),
        mode: PUBLIC,
        userRole: '',
        userId: '',
        activeGoogleConnection: '',
    }),
    actions: {
        updateFilesList(payload) {
            const { currentPath, fileList } = payload;
            this.fileList = fileList;
            this.currentPath = currentPath;
        },
        addToUploadQueue(newItem) {
            this.uploadQueue.push(newItem);
        },
        updateUploadQueue(id, url) {
            const idxFile = this.uploadQueue.findIndex((x) => x.id === id);
            this.uploadQueue[idxFile].uploaded = true;
            this.uploadQueue[idxFile].url = url;
        },
        cleanUploadQueueHistory() {
            this.uploadQueue = this.uploadQueue.filter(x => !x.uploaded);
        },
        updateActiveObject(item) {
            var _a;
            if (((_a = this.activeItem) === null || _a === void 0 ? void 0 : _a._id) === item._id) {
                this.activeItem = {};
                return;
            }
            this.activeItem = item;
        },
        updateActiveExternalObject(item) {
            var _a;
            if (((_a = this.activeItem) === null || _a === void 0 ? void 0 : _a._id) === item.id) {
                this.activeItem = {};
                return;
            }
            this.activeItem = item;
            this.activeItem._id = item.id;
        },
        updateDirectory(item) {
            if (!item)
                this.directoryRoute = [];
            else
                this.directoryRoute.push(item);
        },
        updateMetaInfo(param) {
            var _a;
            this.altId = param.altId;
            this.altType = param.altType;
            this.allowedExtensions = param.allowedExtensions;
            this.maxUploadSize = param.maxUploadSize;
            // this.appState = param.appState
            this.selfHosted = param.selfHosted || false;
            this.contentAIEnable =
                (param === null || param === void 0 ? void 0 : param.contentAIEnableByUser) && (param === null || param === void 0 ? void 0 : param.contentAIEnableInLocation);
            this.mode = (_a = param.mode) !== null && _a !== void 0 ? _a : PUBLIC;
            this.allowMultipleFileInsertion = param.allowMultipleFileInsertion;
        },
        updateRetryCount(count) {
            this.retryCount = count;
        },
        updateToken(token) {
            this.tokenId = token;
        },
        updateActiveCategory(payload) {
            this.activeCategory = payload;
        },
        updatePreviewItem(payload) {
            this.previewItem = payload;
        },
        setSelectedItems(payload) {
            this.selectedItems = payload;
            if (this.selectedItems.length > 0)
                this.isMultiSelectMode = true;
            else
                this.isMultiSelectMode = false;
        },
        resetSelectedItems() {
            this.selectedItems = [];
            this.isMultiSelectMode = false;
        },
        setProcessingQueue(payload) {
            this.processingQueue.push(payload);
        },
        resetProcessingQueue() {
            this.processingQueue = [];
        },
        updateProcessingQueue({ _id, status, processed, }) {
            const fileIndex = this.processingQueue.findIndex((x) => x._id === _id);
            if (fileIndex >= 0) {
                this.processingQueue[fileIndex].processed = processed;
                this.processingQueue[fileIndex].status = status;
            }
        },
        setGoogleConnectInfo(payload) {
            this.googleConnectionInfo = payload;
        },
        isFeatureActive() {
            const now = new Date();
            const exemptedAgencies = [
                '5DP4iH6HLkQsiKESj6rh',
                'YuTUZlUtrwBtvmgByZDW',
                'ktapXmiRvMM4pJHyN3b3',
            ];
            if (this.companyId &&
                (now >= this.levelUpDate || exemptedAgencies.includes(this.companyId)))
                return true;
            else
                false;
        },
    },
});
